import { EmptyUUID } from '@cbgms/base/utils/uuid'
import { DetermineWorkorderUUIDForContextOptions } from 'contexts/WorkorderContext/use-determine-workorder-uuid-for-context'
import React from 'react'

export interface GetWorkorderUUIDOptions extends DetermineWorkorderUUIDForContextOptions {}

export interface IWorkorderContextExpose {
  isInContext: boolean
  hasBeenProvided: boolean
  getWorkorderUUID: (options: GetWorkorderUUIDOptions) => Promise<string>
}

const defaultContextValue = {
  isInContext: false,
  hasBeenProvided: false,
  getWorkorderUUID: (_options: GetWorkorderUUIDOptions) => new Promise<string>(resolve => resolve(EmptyUUID))
}

export const WorkorderContext = React.createContext<IWorkorderContextExpose>(defaultContextValue)
export default WorkorderContext
